export default __webpack_public_path__ + "static/media/psychic.1ff2b9e2.svg";